import { AmbassadorHeader } from "@/modules/ambassadors/components/ambassador-header";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { Box, ThemeProvider } from "@mui/material";
import { useAmbassadors } from "@/modules/ambassadors/hooks/ambassadors.hook";
import Filters from "@/modules/ambassadors/components/filters";
import DataTable from "@/modules/common/components/tables/data-table";
import { useAmbassadorColumns } from "@/modules/ambassadors/hooks/ambassadors-admin-columns.hook";

export default function AdminView() {
  const {
    page,
    error,
    isLoading,
    inviterId,
    searchTerm,
    totalCount,
    rowsPerPage,
    setInviterId,
    setSearchTerm,
    handleViewLeads,
    isLoadingLeadsCount,
    handlePaginationChange,
    ambassadorsWithLeadsCount,
  } = useAmbassadors();

  const columns = useAmbassadorColumns(isLoadingLeadsCount, handleViewLeads);

  return (
    <ThemeProvider theme={nawyTheme}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: nawyTheme.nawy.spacing.sm,
          p: nawyTheme.nawy.spacing.md,
        }}
      >
        <AmbassadorHeader
          title="Ambassadors"
          loading={isLoading}
          count={totalCount}
        />

        <Filters
          key="filters"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          salesAgentDefaultEmail={undefined}
          setSalesAgentDefaultEmail={() => {}}
          inviterId={inviterId}
          setInviterId={setInviterId}
        />

        <Box sx={{ width: "100%" }}>
          <DataTable
            name="Ambassadors"
            columns={columns}
            rowCount={totalCount}
            data={ambassadorsWithLeadsCount || []}
            showRowCount={false}
            showTopBar={false}
            enableRowSelection={false}
            enableColumnResizing={true}
            showColumnVisibility={false}
            pagination={{ pageIndex: page, pageSize: rowsPerPage }}
            setPagination={handlePaginationChange}
            isLoading={isLoading}
            isError={!!error}
            height="calc(100vh - 135px)"
            width="100%"
            tableLayout="full"
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
